import { makeAutoObservable } from "mobx";

export default class RolesAndPermissionStore {
  showPopup: boolean;
  title: string;
  message: string;
  hasViewRights: boolean;
  hasManageRights: boolean;
  hasManageMerchanrAccountRights: boolean;
  constructor() {
    makeAutoObservable(this);
    this.showPopup = false;
    this.title = "Insufficient Rights to Perform this Action";
    this.message = "No Message";
    /* Denied until the host (Main_Web2) posts the user's real Money rights in the payment-code
       message. Starting at true let every action through in the window before that message landed
       (security finding F02). The API is still the authority; these flags only gate the UI. */
    this.hasViewRights = false;
    this.hasManageRights = false;
    this.hasManageMerchanrAccountRights = false;
  }

  setPermissions(
    hasViewRights: boolean,
    hasManageRights: boolean,
    hasManageMerchanrAccountRights: boolean
  ) {
    this.hasViewRights = hasViewRights;
    this.hasManageRights = hasManageRights;
    this.hasManageMerchanrAccountRights = hasManageMerchanrAccountRights;
  }

  hasPermission(
    key: string,
    showPopup?: boolean,
    message?: string,
    title?: string
  ): boolean {
    let hasPermission = true;
    switch (key) {
      case "view":
        hasPermission = this.hasViewRights;
        break;
      case "manage":
        hasPermission = this.hasManageRights;
        break;
      case "manageMerchantAccount":
        hasPermission =
          this.hasManageRights && this.hasManageMerchanrAccountRights;
        break;
    }
    if (!hasPermission && showPopup) {
      this.showPopup = true;
      this.title = title || "Insufficient Rights to Perform this Action";
      this.message = message || "No Message";
    }
    return hasPermission;
  }

  hasManagePermission(
    message?: string,
    showPopup: boolean = true,
    title?: string
  ) {
    return this.hasPermission("manage", showPopup, message, title);
  }

  hasViewPermission(showPopup?: boolean, message?: string, title?: string) {
    return this.hasPermission("view", showPopup, message, title);
  }

  togglePermissionPopup(showPopup: boolean) {
    this.showPopup = showPopup;
  }

  hasManageMerchantAccountPermission(
    message?: string,
    showPopup: boolean = true,
    title?: string
  ) {
    return  this.hasPermission("manageMerchantAccount", showPopup, message, title);
  }
}

/* One instance shared by the payment shell and the fundraiser module, so the rights the host posts
   once apply to both. */
export const rolesAndPermissionStore = new RolesAndPermissionStore();
